import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { StepsEnum } from '../components/actions-select-plan/store/actions-selected-plan.reducer';
import * as actions from '../components/actions-select-plan/store/actions-selected-plan.actions';
import { IRate } from '@core/models/Rate/Rate.interface';
import { currentStepSelector } from '../components/actions-select-plan/store/actions-seleceted-plan.selector';
import { DateService } from '@core/services';
import { AppState } from '@store/app.reducer';

@Injectable({
  providedIn: 'root',
})
export class ActionsSelectedPlanService {
  constructor(
    private store: Store<AppState>,
    private dateService: DateService,
  ) {}

  nextStep(currentStep: StepsEnum) {
    this.store.dispatch(actions.changeStep({ current_step: currentStep }));
  }

  backStep(currenStep: StepsEnum) {
    this.store.dispatch(actions.changeStep({ current_step: currenStep }));
  }

  selectedRate(rate: IRate) {
    this.store.dispatch(actions.selectedRate({ selected_rate: rate }));
  }

  startTicket(date: Date) {
    const literalDate = this.dateService.parseLiteralDate(date);
    this.store.dispatch(actions.startTicket({ start_ticket: literalDate }));
  }

  ticketAdded() {
    this.store.dispatch(actions.ticketAdded({ ticket_selected: true }));
  }

  ticketDeleted() {
    this.store.dispatch(actions.ticketAdded({ ticket_selected: false }));
  }

  currentStep() {
    return this.store.select(currentStepSelector);
  }

  loading() {
    this.store.dispatch(actions.loading());
  }

  showLoader() {
    this.store.dispatch(actions.showLoader());
  }

  hideLoader() {
    this.store.dispatch(actions.hideLoader());
  }
}
